import { Injectable, ErrorHandler, Injector } from '@angular/core';
import { ILogger } from './logger/i-logger';

@Injectable()
export class LogErrorHandler implements ErrorHandler {
  public constructor(private readonly injector: Injector) {}

  public handleError(error: any): void {
    try {
      const logger: ILogger = this.injector.get(ILogger);

      if (logger) {
        logger.exception(error);
      }
    } catch (err) {
      console.error(err);
    }
  }
}
